import { IconLanguage, IconWorld } from "@tabler/icons-react";

import { useSearchParams } from "react-router-dom";
import { Tabs } from "@mantine/core";
import LanguagesTab from "../components/Languages/LanguagesTab";
import TranslationsTab from "../components/Languages/TranslationsTab";

const Languages = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const handleTabChange = (tab) => {
    setSearchParams({ tab });
  };
  const tabValue = searchParams.get("tab") || "languages";
  return (
    <Tabs
      keepMounted={false}
      variant="outline"
      value={tabValue}
      onChange={(value) => handleTabChange(value)}
    >
      <Tabs.List>
        <Tabs.Tab value="languages" leftSection={<IconLanguage size={12} />}>
          Languages
        </Tabs.Tab>
        <Tabs.Tab value="translations" leftSection={<IconWorld size={12} />}>
          Translations
        </Tabs.Tab>
      </Tabs.List>

      <Tabs.Panel value="languages">
        <LanguagesTab />
      </Tabs.Panel>
      <Tabs.Panel value="translations">
        <TranslationsTab />
      </Tabs.Panel>
    </Tabs>
  );
};

export default Languages;
